import { useMutation } from "@tanstack/react-query";
import { useContext } from "react";
import { AlertBannerContext } from "@kivunova/kivufrontendcommon";
import { fetchGraphQL } from "../../Graphql/utils";
import {
  listBillingCyclesQuery,
  getBillingCycleQuery,
  createBillingCycleMutation,
  updateBillingCycleMutation,
} from "../../Graphql/querries/billingCycleQuery";
import {
  ListBillingCyclesResponse,
  GetBillingCycleResponse,
  CreateBillingCycleResponse,
  UpdateBillingCycleResponse,
  ListBillingCyclesInput,
  GetBillingCycleInput,
  CreateBillingCycleInput,
  UpdateBillingCycleInput,
} from "../../Graphql/types/billingCycle";

export const useGetBillingCycleList = () => {
  const { setAlert } = useContext(AlertBannerContext);

  return useMutation<
    ListBillingCyclesResponse,
    Error,
    ListBillingCyclesInput | void
  >({
    mutationKey: ["listBillingCycles"],
    mutationFn: (input) =>
      fetchGraphQL(listBillingCyclesQuery, { input: input ?? {} }, setAlert),
  });
};

export const useGetBillingCycleDetail = () => {
  const { setAlert } = useContext(AlertBannerContext);

  return useMutation<GetBillingCycleResponse, Error, GetBillingCycleInput>({
    mutationKey: ["getBillingCycle"],
    mutationFn: (input) =>
      fetchGraphQL(getBillingCycleQuery, { input }, setAlert),
  });
};

export const useCreateBillingCycle = () => {
  const { setAlert } = useContext(AlertBannerContext);

  return useMutation<
    CreateBillingCycleResponse,
    Error,
    CreateBillingCycleInput
  >({
    mutationKey: ["createBillingCycle"],
    mutationFn: (input) =>
      fetchGraphQL(createBillingCycleMutation, { input }, setAlert),
  });
};

export const useUpdateBillingCycle = () => {
  const { setAlert } = useContext(AlertBannerContext);

  return useMutation<
    UpdateBillingCycleResponse,
    Error,
    { billingCycleId: string; input: UpdateBillingCycleInput }
  >({
    mutationKey: ["updateBillingCycle"],
    mutationFn: ({ billingCycleId, input }) =>
      fetchGraphQL(
        updateBillingCycleMutation,
        { billingCycleId, input },
        setAlert,
      ),
  });
};
